/*******************************************************************************
 * Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>
 *
 * This file BasketAddAnimation.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * BasketAddAnimation.js can not be copied and/or distributed
 * without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
 ******************************************************************************/
export default {
    data() {
        return {}
    },
    methods: {
        setAnimationComponent(target, ticket, callback) {
            let self = this,
                transition = 600,
                elementId = `${target}${ticket.id}`,
                element = document.getElementById(elementId),

                /**
                 * @param clone.widget
                 * @param {Object} clone.style
                 * @param clone.id
                 * @type {Node} clone
                 */
                clone = element.cloneNode(true);

            element.style.position = 'relative';

            clone.id = elementId + '--clone';
            clone.style.position = 'absolute';
            clone.style.zIndex = 9999999999;
            clone.style.opacity = 0.5;
            clone.widget = element.width;
            clone.style.backgroundColor = 'white';
            clone.style.transition = `transform ${transition}ms  ease-out, opacity ${transition}ms  ease-out`;

            let ticketReference = document.getElementById(elementId);

            // create the clone behind the original
            ticketReference.appendChild(clone);

            let basketElm = document.getElementById('basket-modal-wrapper-trigger'),
                bodyRect = document.body.getBoundingClientRect(),
                targetPosRight = document.body.clientWidth,
                elementRect = element.getBoundingClientRect(),
                cloneTopPosition = elementRect.top - bodyRect.top,
                relativeTop = cloneTopPosition - self.offset(basketElm).top;

            clone.style.opacity = 0;
            clone.style.transform = `translate(${targetPosRight}px,${relativeTop * -1}px)`;


            return self.animDelay(transition)
                .then(function () {
                    element
                        .removeChild(clone);
                    self.clearToastr();
                    return self.animDelay(transition / 2)
                        .then(function () {
                            return callback();
                        });

                });

        },
        animDelay(t, v) {
            return new Promise(function (resolve) {
                setTimeout(resolve.bind(null, v), t)
            });
        },

        offset(el) {
            let rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
        }

    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/basket/BasketAddAnimation.js